import { render, staticRenderFns } from "./GenericErrorLayout.vue?vue&type=template&id=0e8f7ef8&scoped=true&"
import script from "./GenericErrorLayout.vue?vue&type=script&lang=js&"
export * from "./GenericErrorLayout.vue?vue&type=script&lang=js&"
import style0 from "./GenericErrorLayout.vue?vue&type=style&index=0&id=0e8f7ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8f7ef8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Logo/Logo.vue').default})
